import React from "react";
import { Helmet } from "react-helmet-async";
import Heading from "../components/common/Heading";
import About from "../components/home/About";
import Attraction from "../components/home/Attraction";
import QuickFacts from "../components/common/QuickFacts";

export default function AboutUs() {
  return (
    <>
      <Helmet>
        <title>About Us | HariKunj Resort Jodhpur — Royal Heritage Stay</title>
        <meta
          name="description"
          content="Discover the rich heritage and story of HariKunj Resort in Jodhpur, Rajasthan. Learn about our traditional Rajasthani sandstone architecture, royal hospitality, and lush green lawns."
        />
        <link rel="canonical" href="https://harikunjresort.com/about" />
        <meta property="og:title" content="About Us | HariKunj Resort Jodhpur — Royal Heritage Stay" />
        <meta property="og:description" content="Discover the rich heritage and story of HariKunj Resort in Jodhpur, Rajasthan. Learn about our traditional Rajasthani sandstone architecture, royal hospitality, and lush green lawns." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://harikunjresort.com/about" />
        <meta property="og:image" content="https://harikunjresort.com/assets/img/about-12.webp" />
      </Helmet>

      <Heading heading="About Us" title="Home" subtitle="About Us" />

      <h1 className="visually-hidden">
        About HariKunj Resort Jodhpur — Royal Heritage, Architecture &amp; Hospitality
      </h1>

      <About />
      <Attraction />
      <QuickFacts pageTitle="About Us" />
    </>
  );
}
